/**
 * @fileOverview 어플리케이션 상수 파일
 * @author
 * @license IDP v1.0.0
 */

export const APP_MENU_ROOT = 'menu_10000';
